module.exports = __webpack_public_path__ + "static/media/BookIcon.7ba4fbd7.svg";